import { canonicalCellOrder, TABLE_IDS } from '../state/board.js';
const EXACT_PUBLIC_ZONES = ['board', 'discard', 'attachment'];
/**
 * Builds an observation-pure target context. The function is safe on either an
 * authoritative state or a redacted snapshot: opponent hidden zones and all
 * deck/armed identities are ignored in both cases.
 */
export function buildPublicTargetContext(state, viewerId, registry) {
    const viewer = state.players[viewerId];
    if (viewer === undefined)
        throw new Error(`buildPublicTargetContext: неизвестный viewer "${viewerId}"`);
    const cells = canonicalCellOrder.flatMap((cellId) => {
        const cell = state.board.cells[cellId];
        return cell === undefined ? [] : [{
                cellId: cell.id,
                tableId: cell.tableId,
                laneIndex: cell.laneIndex,
                side: cell.side,
                occupantId: cell.occupantId,
            }];
    });
    const units = cells.flatMap((cell) => {
        if (cell.occupantId === null)
            return [];
        const instance = state.instances[cell.occupantId];
        if (instance === undefined || instance.zone !== 'board' || instance.cellId !== cell.cellId)
            return [];
        return [{
                instanceId: instance.id,
                seq: instance.seq,
                ownerId: instance.ownerId,
                controllerId: instance.controllerId,
                isToken: instance.isToken === true,
                cellId: cell.cellId,
                side: cell.side,
                ...(registry.get(instance.defId)?.type === undefined
                    ? {}
                    : { cardType: registry.get(instance.defId).type }),
                heat: instance.heat ?? 0,
                freeze: instance.freeze ?? 0,
                stats: structuredClone(instance.stats),
                vars: structuredClone(instance.vars),
                traits: [...(registry.get(instance.defId)?.traits ?? [])],
            }];
    });
    const cards = Object.values(state.instances)
        .filter((instance) => EXACT_PUBLIC_ZONES.includes(instance.zone)
        || (instance.ownerId === viewerId && instance.zone === 'hand'))
        .sort((a, b) => a.seq - b.seq || a.id.localeCompare(b.id))
        .map((instance) => ({
        instanceId: instance.id,
        seq: instance.seq,
        ownerId: instance.ownerId,
        controllerId: instance.controllerId,
        zone: instance.zone,
    }));
    const players = Object.values(state.players)
        .sort((a, b) => a.side === b.side ? a.id.localeCompare(b.id) : a.side === 'A' ? -1 : 1)
        .map((player) => ({
        playerId: player.id,
        side: player.side,
        health: player.health,
        resources: {
            energy: player.resources.energy,
            energyMax: player.resources.energyMax,
            temporaryEnergy: player.resources.temporaryEnergy,
        },
        handCount: player.hand.length,
        deckCount: player.deck.length,
        discardCount: player.discard.length,
        armedReactionCount: player.armedReactions.length,
    }));
    return {
        viewerId,
        viewerSide: viewer.side,
        round: state.round,
        phase: state.phase,
        units,
        cards,
        cells,
        tables: TABLE_IDS.map((tableId) => ({
            tableId,
            cells: cells.filter((cell) => cell.tableId === tableId),
        })),
        players,
        rules: structuredClone(state.rules),
    };
}
//# sourceMappingURL=publicContext.js.map